export default "__VITE_ASSET__i26WegzI__"